import { LinkAudit } from "./pages/LinkAudit/LinkAudit";
import { LinksList } from "./pages/ListLinks/LinksList";
import { LinkDetails } from "./pages/LinkDetails/LinkDetails";
import { CreateLink } from "./pages/CreateLink/CreateLink";
import { allowedGroups } from "./contexts/AuthorizationContext";

const AppRoutes = [
  {
    index: true,
    element: <LinksList itemsPerPage={15} />,
    groups: [allowedGroups.NLS, allowedGroups.PROSPECT],
  },
  {
    path: "/links",
    element: <LinksList itemsPerPage={15} />,
    groups: [allowedGroups.NLS, allowedGroups.PROSPECT],
  },
  {
    path: "/links/:id",
    element: <LinkDetails />,
    groups: [allowedGroups.NLS, allowedGroups.PROSPECT],
  },
  {
    path: "/links/:id/history",
    element: <LinkAudit />,
    groups: [allowedGroups.NLS, allowedGroups.PROSPECT],
  },
  {
    path: "/links/new",
    element: <CreateLink />,
    groups: [allowedGroups.PROSPECT],
  },
];

export default AppRoutes;
